enum OrderStatus {
  created = 'created',
  delivered = 'delivered',
  processing = 'processing',
  failed = 'failed',
  failedToDeliver = 'failed_to_deliver',
  paid = 'paid',
  refunded = 'refunded',
  refundFailed = 'refund_failed',
}

export default OrderStatus
